export default {
  globals: {
    colors: {
      black: '#333',
      darkGray: '#46484B',
      darkGrayLine: '#ABABAB',
      lightGray: '#737373',
      lightGrayLine: '#D2D4D8',
      mediumGray: '#606469',
      lightGrayPopup: '#EBEDF2',
      lightGrayBlock: '#F7F7F7',
      lightGrayDescription: '#9A9A9A',
      borderGray: '#D7DCE2',
      background: '#FFFFFF',
      titleIconsColor: '#A6CE39',
      contactIconsColor: '#116C3A',
      arrowIconColor: '#46484B' // Loader/buttons colors, vivus/onea themes have them
      // primary: '#A6CE39',
      // secondary: '#006D38',
    }
  }
};